module.exports = __webpack_public_path__ + "assets/google-translate-demo-872de709cb321438bedcc7da9801da35.mp4";